import { Component, OnInit, Input } from '@angular/core';
import { InfoWidget } from '../info-widget/info-widget.component';

@Component({
  selector: 'app-info-widget-group',
  templateUrl: './info-widget-group.component.html',
  styleUrls: ['./info-widget-group.component.css']
})
export class InfoWidgetGroupComponent implements OnInit {
	@Input() infoWidgetGroup: InfoWidgetGroup;
	@Input() title = '';
	constructor() { }

	ngOnInit() {
		this.infoWidgetGroup = this.infoWidgetGroup || new InfoWidgetGroup({
			widgets: []
		});
		console.log('InfoWidgetGroupComponent init');
	}

}

export class InfoWidgetGroup {
	widgets: InfoWidget[][];
	constructor(opts: {widgets:  InfoWidget[][]}) {
		Object.assign(this, opts);
		this.widgets = this.widgets || [];
	}
	get rows() {
		return this.widgets.length;
	}
	get className() {
		return `col-md-12 col-lg-12 col-xl-${12 / this.rows}`;
	}
}
